import React from 'react';
import './SkeletonPlanCard.css';

export default function SkeletonPlanCard({ count = 4 }) {
  return (
    <div className="plans-row" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="plan-card-wrap plan-skel-wrap" data-plan-card="1">
          <div className="plan-card-inner plan-skel-inner">
            {/* Head */}
            <div className="plan-head">
              <div className="sk sk-title shimmer" />
              <div className="sk sk-price shimmer" />
            </div>

            {/* Chip */}
            <div className="plan-meta">
              <div className="sk sk-chip shimmer" />
            </div>

            {/* Groups (match real layout) */}
            <div className="plan-groups">
              {/* Enhancements */}
              <div className="plan-group plan-skel-group">
                <div className="sk sk-group-title shimmer" />

                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v shimmer" />
                </div>
              </div>

              {/* Creator Hub */}
              <div className="plan-group plan-skel-group">
                <div className="sk sk-group-title shimmer" />

                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
              </div>

              {/* Marketplace */}
              <div className="plan-group plan-skel-group">
                <div className="sk sk-group-title shimmer" />

                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
                <div className="plan-group-item">
                  <span className="sk sk-k shimmer" />
                  <span className="sk sk-v-icon shimmer" />
                </div>
              </div>
            </div>

            {/* Button */}
            <div className="plan-actions">
              <div className="sk sk-btn shimmer" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
